// extracted by mini-css-extract-plugin
export var headerCell = "_4l-1";
export var loadingSpinnerContainer = "_4l-4";
export var rowWrapper = "_4l-3";
export var standaloneTable = "_4l-5";
export var table = "_4l-0";
export var white = "_4l-2";